module.exports = __webpack_public_path__ + "static/BTP-graphic2-400-8514a48a56e2ba7c12563da11cd9f2fa.png";